import { render, staticRenderFns } from "./GuardShield.vue?vue&type=template&id=66c2ca46&lang=html"
import script from "./GuardShield.vue?vue&type=script&lang=js"
export * from "./GuardShield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports